var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex flex-col max-w-7xl mx-auto my-10" }, [
    _c(
      "div",
      {
        staticClass:
          "-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
      },
      [
        _vm.isLoading ? _c("div", [_c("Spinner")], 1) : _vm._e(),
        _c("div", { staticClass: "flex my-2 justify-between items-center" }, [
          _c("div", { staticClass: "text-gray-400 italic font-thin text-sm" }, [
            _vm._v(
              " Note: Abandoned carts without phone number are automatically hidden. "
            )
          ]),
          _c("div", [
            _c(
              "button",
              {
                staticClass:
                  "inline-flex items-center px-4 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-50 focus:outline-none focus:border-indigo-300 focus:shadow-outline-indigo active:bg-indigo-200 transition ease-in-out duration-150 mr-2",
                attrs: { type: "button" },
                on: { click: _vm.openTemplates }
              },
              [_vm._v(" Templates ")]
            ),
            _c(
              "button",
              {
                staticClass:
                  "inline-flex items-center px-4 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-50 focus:outline-none focus:border-indigo-300 focus:shadow-outline-indigo active:bg-indigo-200 transition ease-in-out duration-150",
                attrs: { type: "button", disabled: _vm.isLoading },
                on: { click: _vm.refreshCurrentPage }
              },
              [
                _vm._v(" Refresh"),
                _vm.isLoading ? _c("span", [_vm._v("ing")]) : _vm._e()
              ]
            )
          ])
        ]),
        _c("div", { staticClass: "flex flex-col" }, [
          _c(
            "div",
            {
              staticClass:
                "-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8 "
            },
            [
              _c("ManualMessageAlert"),
              _vm.checkouts.docs && _vm.checkouts.docs.length > 0
                ? _c(
                    "div",
                    {
                      staticClass:
                        "align-middle inline-block min-w-full shadow  sm:rounded-lg border-b border-gray-200 mb-8"
                    },
                    [
                      _c("table", { staticClass: "min-w-full" }, [
                        _vm._m(0),
                        _c(
                          "tbody",
                          { staticClass: "bg-white" },
                          _vm._l(_vm.checkouts.docs, function(checkout) {
                            return _c("CartListItem", {
                              key: checkout.id,
                              attrs: { checkout: checkout },
                              on: { refreshCurrentPage: _vm.refreshCurrentPage }
                            })
                          }),
                          1
                        )
                      ]),
                      _c("Pagination", {
                        attrs: { page: _vm.checkouts },
                        on: { pageChanged: _vm.loadPage }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isLoading &&
              _vm.checkouts.docs &&
              _vm.checkouts.docs.length === 0
                ? _c(
                    "div",
                    {
                      staticClass:
                        "align-middle inline-block min-w-full  overflow-hidden text-center py-16"
                    },
                    [
                      _vm._v(
                        " You don't have any abandoned carts right now. We will be listing them here as soon a cart is abandoned. "
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", { staticClass: "hidden md:table-row" }, [
        _c(
          "th",
          {
            staticClass:
              "px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
          },
          [_vm._v(" Customer ")]
        ),
        _c(
          "th",
          {
            staticClass:
              "px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
          },
          [_vm._v(" Date ")]
        ),
        _c(
          "th",
          {
            staticClass:
              "px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
          },
          [_vm._v(" Recovery Status ")]
        ),
        _c(
          "th",
          {
            staticClass:
              "px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
          },
          [_vm._v(" Message Status ")]
        ),
        _c(
          "th",
          {
            staticClass:
              "px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
          },
          [_vm._v(" Checkout id ")]
        ),
        _c(
          "th",
          {
            staticClass:
              "px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
          },
          [_vm._v(" Total & last order date ")]
        ),
        _c(
          "th",
          {
            staticClass:
              "px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
          },
          [_vm._v(" Tags ")]
        ),
        _c("th", {
          staticClass: "px-3 py-3 border-b border-gray-200 bg-gray-50"
        })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }